export const authUserQueryKey = ["authGetUser"] as const;
